import { ApolloError } from '@apollo/client';
import { useUserEntitlements } from 'hooks/useUserEntitlements';
import {
  getServices_bookableServices,
  useGetServices,
} from '../useGetServices';

interface UseBookAccessResult {
  loading: boolean;
  error: ApolloError | undefined;
  canAccess: boolean;
  entitlements: ReturnType<typeof useUserEntitlements>['entitlements'];
  bookableServices: getServices_bookableServices[];
}

export const useBookAccess = (): UseBookAccessResult => {
  const {
    entitlements,
    loading: entitlementsLoading,
    error: entitlementsError,
  } = useUserEntitlements();
  const {
    data: servicesData,
    loading: servicesLoading,
    error: servicesError,
  } = useGetServices();

  const loading = entitlementsLoading || servicesLoading;
  const error = servicesError || entitlementsError;
  const bookableServices = servicesData?.bookableServices || [];
  const canAccess = !!(entitlements?.unmindTalk || bookableServices.length);

  return { loading, error, canAccess, entitlements, bookableServices };
};
